<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      Create New Organization
      <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <mat-accordion>
      <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
              <mat-panel-title id="accAccountCodeMaster">
                  <div class="d-flex justify-content-between eip-pt-10 eip-pb-10">
                      <div class="title-container d-flex align-items-center">
                          <mat-label>Business Group</mat-label>
                      </div>
                  </div>
              </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="groupForm">
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Group Short Name</mat-label>
                        <input matInput formControlName="groupShortName" required>
                        <mat-error *ngIf="groupForm.get('groupShortName').hasError('required')">
                            Group short name is required
                        </mat-error>
                    </mat-form-field>
                </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                      <mat-form-field style="width: 100%;">
                          <mat-label>Group Name</mat-label>
                          <input matInput formControlName="groupName" required>
                          <mat-error *ngIf="groupForm.get('groupName').hasError('required')">
                              Group name is required
                          </mat-error>
                      </mat-form-field>
                  </div>                
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                      <mat-form-field style="width: 100%;">
                          <mat-label>Group Code</mat-label>
                          <input matInput formControlName="groupCode">
                      </mat-form-field>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                      <mat-form-field style="width: 100%;">
                          <mat-label>Group Logo URL</mat-label>
                          <input matInput formControlName="groupLogoUrl">
                      </mat-form-field>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                      <mat-form-field floatLabel="always" appearance="none">
                          <mat-label>Active Status</mat-label>
                          <mat-slide-toggle color="primary" formControlName="groupStatus">
                          </mat-slide-toggle>
                          <textarea matInput hidden></textarea>
                      </mat-form-field>
                  </div>
              </div>
          </form>
      </mat-expansion-panel>
  </mat-accordion>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button type="button" class="btn btn-primary" (click)="saveGroup()" id="btnEDMSave" [disabled]="!groupForm.valid"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Submit</button>
      <button type="button" class="btn btn-secondary" (click)="closeDialog()" id="btnEDMCancel"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>
  </div>
</div>